import React from 'react';
import { Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';
import moment from "moment";

// Define styles for your document
const styles = StyleSheet.create({
    page: { padding: 30 },
    table: { display: 'table', width: 'auto', borderStyle: 'solid', borderWidth: 1, borderColor: '#bfbfbf', marginBottom: 10 },
    tableRow: { flexDirection: 'row' },
    tableHeader: { backgroundColor: '#f0f0f0' },
    tableCol: { width: '33.33%', borderStyle: 'solid', borderWidth: 1, borderColor: '#bfbfbf', padding: 5, fontSize: 10, textAlign: 'center' },
    tableCell: { margin: 'auto', marginTop: 5, fontSize: 8 },
    title: { fontSize: 18, textAlign: 'center', marginBottom: 20 },
});

const HistoryPDF = ({ data }) => (
    <Document>
        <Page size="A4" style={styles.page}>
            <View>
                <Text style={styles.title}>History Report</Text>
                <View style={styles.table}>
                    {/* Table Header */}
                    <View style={[styles.tableRow, styles.tableHeader]}>
                        <Text style={styles.tableCol}>Fund Name</Text>
                        <Text style={styles.tableCol}>Asset Type</Text>
                        <Text style={styles.tableCol}>Token Price</Text>
                        <Text style={styles.tableCol}>Total Supply</Text>
                        {/* <Text style={styles.tableCol}>Token Address</Text> */}
                        <Text style={styles.tableCol}>Created At</Text>
                    </View>
                    {/* Table Body */}
                    {data.map((item, index) => (
                        <View style={styles.tableRow} key={index}>
                            <Text style={styles.tableCol}>{item.fundName}</Text>
                            <Text style={styles.tableCol}>{item.assetType}</Text>
                            <Text style={styles.tableCol}>{item.tokenPrice} USD</Text>
                            <Text style={styles.tableCol}>{item.availableTokens}</Text>
                            {/* <Text style={styles.tableCol}>{item.TokenAddress}</Text> */}
                            <Text style={styles.tableCol}>  {moment(item.createdAt).format("lll")}</Text>
                        </View>
                    ))}
                </View>
            </View>
        </Page>
    </Document>
);

export default HistoryPDF;